import { useApolloClient } from "@apollo/client";
import { getDataOrNull } from "@msys/common";
import { useCallback } from "react";
import { QUOTE_ITEM_TYPES } from "../../constants.js";
import type { ItemSelect_ItemFragment } from "../doc-items/ItemSelect.generated.js";
import { getValidMoveTargets } from "../doc-items/tree-helpers.js";
import { useQuoteMoveTargetsLazyQuery } from "./useQuoteMoveTargets.generated.js";

export const useQuoteMoveTargets = ({
  projectId,
  docId,
}: {
  projectId: string;
  docId: string;
}) => {
  const client = useApolloClient();
  const [fetchItems] = useQuoteMoveTargetsLazyQuery({ client });

  const getValidItemMoveTargets = useCallback(
    async (itemIds: string[]): Promise<ItemSelect_ItemFragment[]> => {
      const { data } = await fetchItems({
        variables: { projectId, quoteId: docId },
        fetchPolicy: "no-cache",
      });

      const items = getDataOrNull(data?.quote)?.quote?.items ?? [];

      return getValidMoveTargets(items, itemIds, QUOTE_ITEM_TYPES);
    },
    [fetchItems, projectId, docId]
  );

  return getValidItemMoveTargets;
};
